import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { LanguageSwitch } from '../components/LanguageSwitch';
import { Card, CardContent } from '../components/ui/card';
import { CheckCircle, Heart } from 'lucide-react';

export const Complete = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-black">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 px-6 py-4 flex justify-between items-center">
        <div className="flex items-center gap-3">
          <img src="/apollo-logo.png" alt="Apollo" className="h-10 w-auto" />
        </div>
        <LanguageSwitch />
      </header>

      {/* Main Content */}
      <main className="flex items-center justify-center min-h-screen px-4">
        <Card className="bg-gray-800/90 border-gray-700 max-w-lg w-full backdrop-blur-sm shadow-xl" data-testid="complete-card">
          <CardContent className="pt-12 pb-12 px-8 text-center">
            {/* Success Icon */}
            <div className="relative inline-block mb-6">
              <div className="w-24 h-24 rounded-full bg-orange-500/20 flex items-center justify-center mx-auto">
                <CheckCircle className="w-14 h-14 text-orange-500" />
              </div>
              <div className="absolute -right-1 -bottom-1 w-8 h-8 rounded-full bg-green-500 flex items-center justify-center">
                <Heart className="w-4 h-4 text-white" />
              </div>
            </div>

            {/* Thank You Message */}
            <h1 className="text-3xl sm:text-4xl font-manrope font-bold text-white mb-3" data-testid="complete-title">
              {t('complete.title')}
            </h1>
            <p className="text-orange-500 font-manrope font-semibold mb-6">
              {t('complete.subtitle')}
            </p>

            {/* Message */}
            <p className="text-gray-300 font-dm-sans leading-relaxed mb-8">
              {t('complete.message')}
            </p>

            {/* Footer */}
            <div className="pt-6 border-t border-gray-700">
              <p className="text-gray-500 text-sm font-dm-sans">
                {t('complete.footer')}
              </p>
            </div>

            {/* Apollo Logo */}
            <div className="mt-8">
              <img src="/apollo-logo.png" alt="Apollo" className="h-8 w-auto mx-auto opacity-60" />
            </div>
          </CardContent>
        </Card>
      </main>
    </div>
  );
};
